import { GradingProvider } from './grading-provider';

export enum SectionColumnConfigDataForAssetColumn {
  Contain = 'Contain',
  Cover = 'Cover'
}

export enum SectionColumnConfigDataForSecondaryPriceColumn {
  SecondaryPrice = 'SecondaryPrice',
  PricePerUOM = 'PricePerUOM',
  OriginalPrice = 'OriginalPrice',
  SaleOriginalPrice = 'SaleOriginalPrice',
  OriginalAndSalePrice = 'OriginalAndSalePrice',
  TaxesInPrice = 'TaxesInPrice',
  TaxesInRoundedPrice = 'TaxesInRoundedPrice',
  PreTaxPrice = 'PreTaxPrice'
}

export enum SectionColumnConfigDataForStrainTypeColumn {
  StrainTypeSymbol = 'StrainTypeSymbol',
  StrainTypeWord = 'StrainTypeWord'
}

export enum SectionColumnConfigDataForTopCannabinoid {
  TopCannabinoidWord = 'TopCannabinoidWord'
}

export enum SectionColumnConfigDataForCannabinoidsAndTerpenesColumn {
  NumericValue = 'NumericValue',
  PresenceIcon = 'PresenceIcon',
  // front-end only: the list cannabinoids column passes this so the primary cannabinoid '<1' rule is skipped
  ListNumericValue = 'ListNumericValue'
}

export enum SectionColumnConfigDataBadgeMode {
  Badge = 'Badge'
}

export enum SectionColumnConfigDataForAdditionalDetailsColumns {
  PlainText = 'PlainText'
}

export type SectionColumnConfigDataValue =
  | SectionColumnConfigDataForAssetColumn
  | SectionColumnConfigDataForSecondaryPriceColumn
  | SectionColumnConfigDataForStrainTypeColumn
  | SectionColumnConfigDataForCannabinoidsAndTerpenesColumn
  | GradingProvider
  | SectionColumnConfigDataBadgeMode
  | SectionColumnConfigDataForTopCannabinoid
  | SectionColumnConfigDataForAdditionalDetailsColumns;
